export default function getConstValues() {
    const NUMBER_OF_WORDS_PER_H2 = parseInt(
        process.env.REACT_APP_NUMBER_OF_WORDS_PER_H2 || "0",
        10
    );
    const NUMBER_OF_WORDS_PER_H3 = parseInt(
        process.env.REACT_APP_NUMBER_OF_WORDS_PER_H3 || "0",
        10
    );
    const NUMBER_OF_KEYWORD_PER_TEXT = parseInt(
        process.env.REACT_APP_NUMBER_OF_KEYWORD_PER_TEXT || "0",
        10
    );

    const MIN_NUMBER_OF_CHAR_IN_META_TITLE = parseInt(
        process.env.REACT_APP_MIN_NUMBER_OF_CHAR_IN_META_TITLE || "0",
        10
    );
    const MAX_NUMBER_OF_CHAR_IN_META_TITLE = parseInt(
        process.env.REACT_APP_MAX_NUMBER_OF_CHAR_IN_META_TITLE || "0",
        10
    );
    const MIN_NUMBER_OF_CHAR_IN_META_DESC = parseInt(
        process.env.REACT_APP_MIN_NUMBER_OF_CHAR_IN_META_DESC || "0",
        10
    );
    const MAX_NUMBER_OF_CHAR_IN_META_DESC = parseInt(
        process.env.REACT_APP_MAX_NUMBER_OF_CHAR_IN_META_DESC || "0",
        10
    );

    const NUMBER_OF_WORDS_BOLD = parseInt(process.env.REACT_APP_NUMBER_OF_WORDS_BOLD || "0", 10);
    const NUMBER_OF_WORDS_ITALIC = parseInt(
        process.env.REACT_APP_NUMBER_OF_WORDS_ITALIC || "0",
        10
    );

    const MAX_NUMBER_OF_MINIMAL_H2 = parseInt(
        process.env.REACT_APP_MAX_NUMBER_OF_MINIMAL_H2 || "0",
        10
    );

    const MAX_NUMBER_OF_MINIMAL_H3 = parseInt(
        process.env.REACT_APP_MAX_NUMBER_OF_MINIMAL_H3 || "0",
        10
    );
    const MAX_LIST = parseInt(process.env.REACT_APP_MAX_LIST || "0", 10);
    return {
        NUMBER_OF_WORDS_PER_H2,
        MAX_NUMBER_OF_MINIMAL_H2,
        NUMBER_OF_WORDS_PER_H3,
        MAX_LIST,
        MAX_NUMBER_OF_MINIMAL_H3,
        NUMBER_OF_KEYWORD_PER_TEXT,
        MIN_NUMBER_OF_CHAR_IN_META_TITLE,
        MAX_NUMBER_OF_CHAR_IN_META_TITLE,
        MIN_NUMBER_OF_CHAR_IN_META_DESC,
        MAX_NUMBER_OF_CHAR_IN_META_DESC,
        NUMBER_OF_WORDS_BOLD,
        NUMBER_OF_WORDS_ITALIC,
    };
}
